// extracted by mini-css-extract-plugin
module.exports = {"main":"LayoutMainCommon_main__2duwz","divider":"LayoutMainCommon_divider__WrYSE"};